import { useNavigate } from "react-router-dom";
import { useTheme } from "../pages/ChatPage/hooks/useTheme";
import { themes, createStyles } from "../pages/ChatPage/styles";

export default function AuthHeader() {
    const navigate = useNavigate();
    const { themeName } = useTheme();
    const theme = themeName === "light" ? themes.light : themes.dark;
    const styles = createStyles(theme);

    const handleGoBack = () => {
        const returnUrl = localStorage.getItem('returnUrl');
        if (returnUrl) {
            navigate(returnUrl);
        } else {
            navigate(-1);
        }
    };

    // Get restaurant and table info from localStorage if available
    const restaurantInfo = localStorage.getItem('currentRestaurant');
    const tableNumber = localStorage.getItem('currentTable');

    let restaurant = null;
    if (restaurantInfo) {
        try {
            restaurant = JSON.parse(restaurantInfo);
        } catch (e) {
            // ignore parse errors
        }
    }

    return (
        <div style={styles.header}>
            <div style={styles.headerLeft}>
                <div style={styles.title}>
                    {restaurant?.name || "Restaurant"} (Стіл {tableNumber || "?"})
                </div>
                <div style={styles.subtitle}>
                    {restaurant?.address || ""}
                </div>
            </div>

            <div style={styles.headerRight}>
                <button onClick={handleGoBack} style={styles.smallBtn}>
                    Назад до чату
                </button>
            </div>
        </div>
    );
}
